import { Input, Form, Col, Row, Modal, InputNumber, Button } from 'antd';
import React, { Component } from 'react';
import { Spinner } from 'reactstrap';


export class SPSalaryComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            errorMessage: null,
            SPSalary: null,
            visible: false,
            submitSuccess: true,
            commonParamater: null,
            tenantId: null
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId, isLoading: true });
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div style={{ margin: "32px auto", maxWidth: "1000px" }}>
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        onFinish={this.showModal}
                    >
                        <Form.Item label="SP薪资" name="SPSalary"
                            rules={[{ required: true, message: '请填写SP薪资！' }]}
                        >
                            <InputNumber placeholder="请填写SP薪资" min={0} step="100" style={{ width: 300 }} parser={text => /^\d+$/.test(text) ? text : ''} />
                        </Form.Item>
                        <div>
                            <Modal title="录入基本薪资" visible={this.state.visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                                <p>是否确定录入？</p>
                            </Modal>
                        </div>
                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" style={{ marginTop: 40, width: 160 }} htmlType="submit">录入</Button>
                        </Form.Item>
                    </Form>

                </div>
            )
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }

    onFormSubmit = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.setState({ isLoading: false, submitSuccess: true });
        }, 2000)
    }

    showModal = values => {
        this.setState({ SPSalary: values.SPSalary, visible: true });
    }

    handleOk = values => {
        const commonParamater = this.state.commonParamater;
        const tenantId = this.state.tenantId;
        const content = this.state.SPSalary;
        window.location.href = "/mindray/OperationSuccess?commonParamater=" + commonParamater + "&tenantId=" + tenantId + "&content=" + content + "&type=" + 3;
    }

    handleCancel = (e) => {
        this.setState({ visible: false });
    }

}